module.exports = __webpack_public_path__ + "img/back-arrow.3bd6d7e4.svg";